// UpdatesData.js - Contains all updates data separated from the component

export const getAllUpdates = () => {
    return [
      {
        id: 1,
        title: "Born in Albany",
        date: "June 2005",
        description: "i was born in Albany, New York :("
      },
      {
        id: 2,
        title: "Moved to Trinidad",
        date: "2006",
        description: "soon after, I moved to Trinidad"
      },
      {
        id: 3,
        title: "Moved Back to America",
        date: "August 2015",
        description: "i moved back to the states in 5th grade"
      },
      {
        id: 4,
        title: "Graduated High School",
        date: "May 2023",
        description: "FINALLY"
      },
      {
        id: 5,
        title: "Started at New York University",
        date: "August 2023",
        description: "can't believe I got into NYU, diving into computer science, philosophy and the nonstop pace of NYC",
      },
      {
        id: 6,
        title: "Joined FYQA Program at NYU",
        date: "September 2023",
        description: "kicked off the First Year Queers & Allies program at NYU, building community and early leadership skills",
      },
      {
        id: 7,
        title: "IT Intern at Blessed Sacrament",
        date: "June 2024",
        description: "spent a summer as an IT intern at Blessed Sacrament, getting hands-on with real-world tech challenges",
      },
      {
        id: 8,
        title: "Finance & Operations Intern at TLDEF",
        date: "September 2024",
        description: "joined TLDEF as a Finance & Operations Intern under the Richie Jackson Fellowship, helping streamline operations",
        linkedinUrl: "https://www.linkedin.com/posts/faith-winford_internship-transgenderrights-financeandoperations-activity-7237924304020000768-Zs7F"
      },
      {
        id: 9,
        title: "Attended AfroTech 2024 Conference",
        date: "November 2024",
        description: "went to AfroTech 2024 through a Duolingo x RTC scholarship, connecting with Black tech professionals and soaking in new ideas",
        linkedinUrl: "https://www.linkedin.com/posts/faith-winford_afrotech2024-afrotech2025-afrotech2024-activity-7264422615719591936-6A2D?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEUMFL0BQEJBz9lhSz5n8p36fWthhCvifGE"
      },
      {
        id: 10,
        title: "Accepted into Career Development Programs",
        date: "January 2025",
        description: "landed spots in several career programs like MLT Career Prep, SEO Career, Headstart, and CodePath.",
        linkedinUrl: "https://www.linkedin.com/posts/faith-winford_techcommunity-colorstack-rtcscholars-activity-7286246298851131392-Cgne"
      },
      {
        id: 11,
        title: "Attended NSBE 2025 Convention",
        date: "March 2025",
        description: "attended the NSBE 2025 Convention through a Black Girls Code scholarship, networking with fellow engineers",
        linkedinUrl: "https://www.linkedin.com/posts/faith-winford_nsbe-blackgirlscode-blackintech-activity-7295426447186251776--6R4"
      },
      {
        id: 12,
        title: "Became an NYU Resident Assistant",
        date: "March 2025",
        description: "i got accepted to be a Resident Assistant at NYU—committed to building a supportive community",
        linkedinUrl: "https://www.linkedin.com/posts/faith-winford_nyu-residentassistant-communitybuilding-activity-7306073696849330177-MXPp"
      },
      {
        id: 13,
        title: "Accepted into EY & Deloitte Programs",
        date: "March 2025",
        description: "selected for programs with EY and Deloitte, giving me insights into tech consulting and personalized mentorship.",
        linkedinUrl: "https://www.linkedin.com/posts/faith-winford_careerdevelopment-studentleadership-professionalgrowth-activity-7305195890787438593-dtWS"
      }
      ,
      {
        id: 14,
        title: "Completed SEO Tech Developer Fellowship",
        date: "June 2025",
        description: "Completed a full-stack fellowship focused on backend APIs, testing, and product delivery."
      },
      {
        id: 15,
        title: "JPMorgan PM Internship Completed",
        date: "August 2025",
        description: "Finished JPMorgan Chase & Co. Product Management Internship; final demo delivered."
      },
      {
        id: 16,
        title: "ServiceNow Event — CTF 3rd Place & Best Design 1st Place",
        date: "July 2025",
        description: "Placed 3rd in the Capture The Flag competition and won Best Design at the ServiceNow event."
      },
      {
        id: 17,
        title: "ColorStack Stacked Up Summit — Selected Attendee",
        date: "July 2025",
        description: "Selected to attend the ColorStack Stacked Up Summit."
      },
      {
        id: 18,
        title: "MLT Seminar (Houston) — Selected Attendee",
        date: "August 2025",
        description: "Attended the MLT Seminar in Houston — full-day seminar completed."
      },
      {
        id: 19,
        title: "ColorStack × MongoDB Session — Participant",
        date: "October 2025",
        description: "Selected participant in the ColorStack × MongoDB session."
      }
    ];
  };